<ng-container *ngIf="course.syllabus.recommenders">
  <mat-tab-group [ngClass]=AppConfig.theme>
    <mat-tab *ngFor="let recommender of course.syllabus.recommenders" [label]=recommender.name>
      <div class="p-3">
        <h3 class="pt-2">
          {{ recommender.name }}
          <span>| {{ recommender.pos }}</span>
        </h3>
        <p class="p-3" [innerHtml]="recommender.comment">
        </p>
      </div>
    </mat-tab>
  </mat-tab-group>
</ng-container>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabus-recommenders/syllabus-recommenders.component.html